import request from 'api/request';

export default function createCourse(data) {
  return request({ url: `/courses`, method: 'POST', data });
}
